import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { hasUserValidCompanyRole } from "@utils/access-control/company/company-access-control";

interface Props {
  /** The current logged-in user */
  currentUser: FaroCoreApiTypes.CompanyMemberBase | null;

  /** The identity of the member whose role is being changed */
  memberIdentity: string;

  /** The current project role of the member */
  memberProjectRole: string;
}

/**
 * Whether the current user should be prevented from changing their own project role.
 * A Project Admin (RESOURCE_ADMIN) cannot downgrade themselves unless they are also
 * a Company Admin (COMPANY_EXECUTIVE).
 */
export function isProjectAdminSelfDowngrade({
  currentUser,
  memberIdentity,
  memberProjectRole,
}: Props): boolean {
  const isCompanyAdmin = hasUserValidCompanyRole({
    currentUser,
    requiredCompanyRoles: ["COMPANY_EXECUTIVE"],
  });

  const isCurrentUserProjectAdmin =
    memberIdentity === currentUser?.identity &&
    memberProjectRole === "RESOURCE_ADMIN";

  return isCurrentUserProjectAdmin && !isCompanyAdmin;
}
